<template>
    <div id="component-container" ref="chartContainer">
        <b-spinner v-if="!show" class="spinner-center"/>
        <div class="content-pagination" v-if="show">
            <span :title="$t('charts.sentstat.ratiotitle')" id="lemma_token_ratio">{{$t('charts.sentstat.lemmatokenratio')}}
            <span>"{{this.baseData.a.name }}":  </span><span style="color: #d79600">{{resultData.a.LemmaTokenRatio.toFixed(5)}}</span>
            <span>"{{this.baseData.b.name }}":  </span><span style="color: #9e213b">{{resultData.b.LemmaTokenRatio.toFixed(5)}}</span>
            </span>

            <b-button v-if="this.scale === 'linear'" size="sm" @click.prevent="changeScale('logarithmic')" class="scale-button">{{$t('charts.scale.log')}}</b-button>
            <b-button v-if="this.scale === 'logarithmic'" size="sm" @click.prevent="changeScale('linear')" class="scale-button">{{$t('charts.scale.lin')}}</b-button>
        </div>
        <div id="charts">
            <bar-chart :height="chartHeight" style="padding: 0 30px 30px 30px" :chart-data="chart.tokenlen"
                       :options="setOptions('tokenlen')" v-if="show"></bar-chart>
            <hr v-if="show">
            <bar-chart :height="chartHeight" style="padding: 0 30px 30px 30px" :chart-data="chart.sentcharlen"
                       :options="setOptions('sentcharlen')" v-if="show"></bar-chart>
            <hr v-if="show">
            <bar-chart :height="chartHeight" style="padding: 0 30px 30px 30px" :chart-data="chart.senttokenlen"
                       :options="setOptions('senttokenlen')" v-if="show"></bar-chart>
            <hr v-if="show">
            <bar-chart :height="chartHeight" style="padding: 0 30px 30px 30px" :chart-data="chart.sentverblen"
                       :options="setOptions('sentverblen')" v-if="show"></bar-chart>
        </div>
    </div>
</template>

<script>
    import BarChart from '../components/BarChart'
    import axios from 'axios'

    export default {
        name: 'SentStat',
        props: {
            taskId: {
                type: String
            }
        },
        components: {BarChart, axios},
        data () {
            return {
                resultData: null,
                baseData: null,
                chartHeight: 470,
                show: false,
                scale: 'linear',
                language: this.$i18n.locale,
                displayLegend: true
            }
        },
        created () {
            window.addEventListener('resize', this.handleResize)
            setTimeout(() => {
                this.sentStat()
            }, 500)
            this.getLabels()
        },
        beforeDestroy: function () {
            window.removeEventListener('resize', this.handleResize)
        },
        computed: {
            chart: function () {
                return {
                    tokenlen: {
                        labels: [],
                        datasets: [
                            {
                                label: 'A',
                                backgroundColor: '#d79600',
                                pointBackgroundColor: 'white',
                                borderWidth: 1,
                                data: []
                            },
                            {
                                label: 'B',
                                backgroundColor: '#9e213b',
                                pointBackgroundColor: 'white',
                                borderWidth: 1,
                                data: []
                            }],
                        legend: { // hides the legend
                            display: false
                        }
                    },
                    sentcharlen: {
                        labels: [],
                        datasets: [
                            {
                                label: 'A',
                                backgroundColor: '#d79600',
                                pointBackgroundColor: 'white',
                                borderWidth: 1,
                                data: []
                            },
                            {
                                label: 'B',
                                backgroundColor: '#9e213b',
                                pointBackgroundColor: 'white',
                                borderWidth: 1,
                                data: []
                            }],
                        legend: { // hides the legend
                            display: false
                        }
                    },
                    senttokenlen: {
                        labels: [],
                        datasets: [
                            {
                                label: 'A',
                                backgroundColor: '#d79600',
                                pointBackgroundColor: 'white',
                                borderWidth: 1,
                                data: []
                            },
                            {
                                label: 'B',
                                backgroundColor: '#9e213b',
                                pointBackgroundColor: 'white',
                                borderWidth: 1,
                                data: []
                            }],
                        legend: { // hides the legend
                            display: false
                        }
                    },
                    sentverblen: {
                        labels: [],
                        datasets: [
                            {
                                label: 'A',
                                backgroundColor: '#d79600',
                                pointBackgroundColor: 'white',
                                borderWidth: 1,
                                data: []
                            },
                            {
                                label: 'B',
                                backgroundColor: '#9e213b',
                                pointBackgroundColor: 'white',
                                borderWidth: 1,
                                data: []
                            }],
                        legend: { // hides the legend
                            display: false
                        }
                    }
                }
            },
            translations () {
                return this.$t('helloworld')
            }
        },
        watch: {
            translations: function () {
                this.language = this.$i18n.locale
                this.redrawChart()
            },
            language: function () {
                this.setLabels()
            },
            scale: function () {
                this.redrawChart()
            }
        },
        methods: {
            sentStat: function () {
                axios.get(process.env.ROOT_API + 'getData/' + this.taskId + '/sentstat')
                    .then((response) => {
                        if (response.data.error === 'corpus not processed') {
                            this.$router.push({path: '/'})
                        } else {
                            this.resultData = response.data
                            console.log('result', this.resultData)
                            this.chartHeight = this.$refs.chartContainer.clientHeight - 60
                            this.renderChart()
                        }
                    }).catch(function (error) {
                        // handle error
                        alert(error)
                    })
                    .finally(function () {
                        // always executed
                    })
            },
            getLabels: function () {
                axios.get(process.env.ROOT_API + 'getData/' + this.taskId + '/base')
                    .then((response) => {
                        if (response.data.error === 'corpus not processed') {
                            console.log(response.data.error)
                            this.$router.push({path: '/'})
                        } else {
                            this.baseData = response.data
                        }
                    }).catch(function (error) {
                        // handle error
                        alert(error)
                    })
                    .finally(function () {
                        // always executed
                    })
            },
            setLabels: function () {
                this.chart.tokenlen.datasets[0].label = '"' + this.baseData.a.name + '" [ ' + this.$t('charts.sentstat.mean') + ' ' + this.resultData.a.tokenlen.mean.toFixed(2) + ' ]'
                this.chart.senttokenlen.datasets[0].label = '"' + this.baseData.a.name + '" [ ' + this.$t('charts.sentstat.mean') + ' ' + this.resultData.a.senttokenlen.mean.toFixed(2) + ' ]'
                this.chart.sentcharlen.datasets[0].label = '"' + this.baseData.a.name + '" [ ' + this.$t('charts.sentstat.mean') + ' ' + this.resultData.a.sentcharlen.mean.toFixed(2) + ' ]'
                this.chart.sentverblen.datasets[0].label = '"' + this.baseData.a.name + '" [ ' + this.$t('charts.sentstat.mean') + ' ' + this.resultData.a.sentverblen.mean.toFixed(2) + ' ]'
                this.chart.tokenlen.datasets[1].label = '"' + this.baseData.b.name + '" [ ' + this.$t('charts.sentstat.mean') + ' ' + this.resultData.b.tokenlen.mean.toFixed(2) + ' ]'
                this.chart.senttokenlen.datasets[1].label = '"' + this.baseData.b.name + '" [ ' + this.$t('charts.sentstat.mean') + ' ' + this.resultData.b.senttokenlen.mean.toFixed(2) + ' ]'
                this.chart.sentcharlen.datasets[1].label = '"' + this.baseData.b.name + '" [ ' + this.$t('charts.sentstat.mean') + ' ' + this.resultData.b.sentcharlen.mean.toFixed(2) + ' ]'
                this.chart.sentverblen.datasets[1].label = '"' + this.baseData.b.name + '" [ ' + this.$t('charts.sentstat.mean') + ' ' + this.resultData.b.sentverblen.mean.toFixed(2) + ' ]'
            },
            setOptions: function (property) {
                return {
                    title: {
                        display: true,
                        text: this.$t('charts.sentstat.' + property)
                    },
                    legend: {
                        display: this.displayLegend
                    },
                    scales: {
                        yAxes: [{
                            type: this.scale,
                            scaleLabel: {
                                display: true,
                                labelString: this.$t('charts.sentstat.frequency')
                            }
                        }],
                        xAxes: [{
                            scaleLabel: {
                                display: true,
                                labelString:
                                    this.$t('charts.sentstat.' + property)
                            }
                        }]
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    height: 200
                }
            },
            renderChart: function () {
                let dataSet = 0
                for (var corpora in this.resultData) {
                    for (var prop in this.resultData[corpora]) {
                        // console.log(prop, dataSet)
                        for (var label in this.resultData[corpora][prop]['hist']) {
                            corpora === 'a' ? dataSet = 0 : dataSet = 1
                            if (dataSet === 0) {
                                this.chart[prop].labels.push(label)
                            } else if (dataSet === 1) {
                                this.chart[prop].labels.push(label)
                                let labelSet = new Set(this.chart[prop].labels)
                                this.chart[prop].labels = Array.from(labelSet)
                            }
                            this.chart[prop].datasets[dataSet].data.push(this.resultData[corpora][prop]['hist'][label])
                        }
                    }
                    // console.log(this.chart[0].labels)
                }
                // this.renameLabels()
                this.setLabels()
                this.show = true
                // console.log(this.chart)
            },
            resizeChart: function () {
                if (window.innerWidth > 768) {
                    this.chartHeight = Math.ceil(this.$refs.chartContainer.clientHeight - 60)
                } else {
                    this.chartHeight = Math.ceil(470)
                }
            },
            redrawChart: function () {
                this.show = false
                this.resizeChart()
                setTimeout(() => {
                    this.show = true
                }, 0)
            },
            handleResize (event) {
                this.redrawChart()
            },
            changeScale (scale) {
                this.scale = scale
            }
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .content-pagination {
        /*position: relative;/*/
        height: 50px;
        padding: 10px;
        /*display:inline-block;*/
    }

    .scale-button {
        float: right;
        margin-right: 30px;
    }

    #charts {
        background-color: white;
        height: calc(100% - 50px);
        width: 100%;
        overflow: auto;
    }
    #lemma_token_ratio {
        height: 30px;
        padding: 10px;
        color: #6c757d;
    }
</style>



// WEBPACK FOOTER //
// src/views/SentStat.vue